import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import { setbadgeJson } from "BadgeDesignAction";

const InputLabelToggle = (props) => {
  /* Toggale beetween input box and label */
  const toggleInputLabel = (id, dpOrderNo) => {
    let { templateJson } = props;
    let arrIndex = _.findIndex(templateJson, function (o) {
      return o.id == id;
    });

    templateJson[arrIndex].label = !templateJson[arrIndex].label;

    props.setbadgeJson(templateJson); // Update to store
  };

  const { classAsProp, idAsProp } = props;

  return (
    <div className="badge-element-button-container">
      <i
        className={classAsProp}
        style={props.styleAsProp}
        onClick={(e) => toggleInputLabel(idAsProp)}
      ></i>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    templateJson: state.templateJson,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setbadgeJson,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InputLabelToggle);
